import mapStyle from '../styles/map-style.json';
export var defaultCenter = {
    lat: 56.130367, // Roughly center of Canada
    lng: -106.346771
};
export var mapOptions = {
    center: defaultCenter,
    zoom: 4,
    maxBounds: [
        [-150, 40], // Southwest coordinates
        [-50, 85] // Northeast coordinates
    ],
    style: mapStyle
};
export var containerStyle = {
    width: '100%',
    borderRadius: '8px',
    overflow: 'hidden'
};
